import React,{history,useEffect, useState, useMemo } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import Services from "../../services/services";
import $, { parseJSON } from 'jquery';
import UsNumberValidate from '../../utility/usNumberValidate';
import { useNavigate } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
const CompanyRegister = () => {
  const [itemName, setFieldName] = useState('');
  const navigate = useNavigate();
  const [stateData, setStateData] = useState([]);
  const [categories, setCategory] = useState([]);
  const [locationCounty, setLocationCounty] = useState([]);
  const [companyProfile, setCompanyProfile] = useState([]);
  const userIdChkLogin=sessionStorage.getItem("logUserId");

  const [pwd, setPwd] = useState('');
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isRevealConfPwd, setIsRevealConfPwd] = useState(false);
  const [showPwdImg, setShowPwdImg] = useState('/images/hide-password.svg');
  const [hidePwdImg, setHidePwdImg] = useState('/images/show-password.svg');

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all",mode: "onBlur"
  });

  function handleChangeProfileDesc(content) {
    setCompanyProfile(content);
  }

  function handleImageUploadBefore(files, info, uploadHandler) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1 = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      Services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }
  function goLogin(){
    navigate("/Home?loginRedirect=1");
  }
  function validateCheck(){
    const checked=$('input[name="category"]:checked').length;

    if (checked >= 3) {
      $('input[name="category"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="category"]').prop('disabled', false);
    }
  }
  function goLogin(){
    //navigate("/Home?loginRedirect=1");
    window.location.href = "/Home?loginRedirect=1";
   }

  const submitValue=()=>
  {


    var passwordConf = $("#passwordConf").val();
   var passwordCheck = $("#adminPassword").val();

   if(passwordConf != passwordCheck){
    $("#matchPwd").show();
    $("#passwordConf").focus();
    return false;
   }else{
    $("#matchPwd").hide();
   }


   var validateEditorTxt = 1;
   if(companyProfile == ""){
     $("#companyProfileValidMsg").show();
    // $("#jobSummaryValidMsg").focus();
    $(window).scrollTop($('#companyProfileValidMsg').position().top);
     validateEditorTxt = 0;
   }

   var jobshadow_concert = "";

   $.each($("input[name='job_shadow']:checked"), function(){
      jobshadow_concert = $(this).val();
  });

  /*if(jobshadow_concert == ""){
    $("#jobShadowValidMsg").show();
   // $("#jobSummaryValidMsg").focus();
   $(window).scrollTop($('#jobShadowValidMsg').position().top);
    validateEditorTxt = 0;
  }else{
    $("#jobShadowValidMsg").hide();
  } */

   //jobShadowValidMsg
   if(validateEditorTxt == 0){
    return false;
   }

      var categoriesArray = [];

      $.each($("input[name='category']:checked"), function(){
        categoriesArray.push($(this).val());
    });

      console.log(categoriesArray);

      const categoryData=JSON.stringify(categoriesArray);
      console.log(categoryData);



       const str = $("#yourphone2").val();
       const contactNumber=str.replace(/[^a-zA-Z0-9]/g, "");
       
      const siteId = process.env.React_App_SITE_ID;//"2";
      var accessTokenTov=sessionStorage.getItem("accToken");
          const requestObject=
          {
            "siteId" : siteId,
            "schoolId" : "1",
            "firstName" : $("#adminFirstName").val(),
            "lastName" : $("#adminLastName").val(),
            "password" : $("#adminPassword").val(),
            "isStudent" : "no",
            "name" : $("#cname").val(),
            "address1" : $("#address").val(),
            "address2" : $("#address1").val(),
            "city" : $("#city").val(),
            "state" : $("#state").val(),
            "zip" : $("#zipcode").val(),
            "email" : $("#adminEmail").val(),
            "phone" :  contactNumber,
            "webSite" : $("#websiteUrl").val(),
            "imageUrl" : "",
            "logoUrl" : "",
            "videoUrl" : "",
            "employee" : "",
            "description" : companyProfile,
            "status" : "pending" ,
            "hasAccessToResume" : "yes",
            "hasAccessToJobPosting" : "no",
            "countyId":$("#county").val(),
            //"updatedOn" : "2021-04-16",
             "companyCategory" :categoriesArray,
             "employeeCount" : $("#nofEmp").val()
              //"jobShadowConcert" : jobshadow_concert
          }

          if(jobshadow_concert != ""){
            requestObject.jobShadowConcert = jobshadow_concert;
          }
         console.log(requestObject);
         var accessTokenIn=sessionStorage.getItem("accToken");
         const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    //'Authorization': "Bearer "+accessTokenIn
                    //'Authorization': accessTokenIn
                  },
          body: JSON.stringify(requestObject)
      };
      $(".load-wrap").show();
      Services.registerCompany(requestOptions).then((res) =>
      {
        $(".load-wrap").hide();
        console.log(JSON.stringify(res));
        if(res.success == "false" || res.success == false){
          $("#alertFailMessage").html(res.message);
          $("#alertFailMessage").show();
        }else{
          navigate('/thankyou?r=2');
        }

         // navigate('/thankyou');
      });

  }
  function validateMedium() {
     var mediumCheckboxes = document.getElementsByName("exp");
     var okay = false;

     for (var i = 0, len = mediumCheckboxes.length; i < len; i++) {
         if (mediumCheckboxes[i].checked) {
             okay = true;
             break;
         }
     }

     if (okay) {
         return true;
     } else {
       return false;
     }
 }
 useEffect(() =>
 {
  const jsonData = {
    "companyRegister": {
      
    }
  };

var jsondataformatted = JSON.stringify(jsonData);
sessionStorage.setItem('pagejsonObject', jsondataformatted);

  $(".load-wrap").hide();
  $(".se-dialog-tabs").hide();
  $("#jobShadowValidMsg").hide();
  $("#alertFailMessage").hide();
  $("#companyProfileValidMsg").hide();
  $( "#passwordConf" ).blur(function() {
      var passwordConf = $("#passwordConf").val();
      var passwordCheck = $("#adminPassword").val();
      if(passwordConf != passwordCheck){
      $("#matchPwd").show();
      }else{
      $("#matchPwd").hide();
      }
  });
  $("#matchPwd").hide();
   $('#yourphone2').usPhoneFormat();
   //var accessTokenTov=sessionStorage.getItem("accToken");
   //alert(accessTokenTov);
   Services.getIndustryData().then((res) =>
   {
          console.log("count---179-->"+JSON.stringify(res));
           setCategory(res.data.content);
   })

   Services.getLocationCounty().then((res) => {
    console.log("getLocationCounty data=" + JSON.stringify(res));
    setLocationCounty(res.data.content);
  });

   var statesJson = [{"stateId":4,"stateName":"Alabama","stateCode":"AL"},{"stateId":5,"stateName":"Alaska","stateCode":"AK"},{"stateId":6,"stateName":"Alabama","stateCode":"AL"},{"stateId":7,"stateName":"Arizona","stateCode":"AZ"},{"stateId":8,"stateName":"Arkansas","stateCode":"AR"},{"stateId":9,"stateName":"California","stateCode":"CA"},{"stateId":10,"stateName":"Colorado","stateCode":"CO"},{"stateId":11,"stateName":"Connecticut","stateCode":"CT"},{"stateId":12,"stateName":"Delaware","stateCode":"DE"},{"stateId":13,"stateName":"District of Columbia","stateCode":"DC"},{"stateId":14,"stateName":"Florida","stateCode":"FL"},{"stateId":15,"stateName":"Georgia","stateCode":"GA"},{"stateId":16,"stateName":"Hawaii","stateCode":"HI"},{"stateId":17,"stateName":"Idaho","stateCode":"ID"},{"stateId":18,"stateName":"Illinois","stateCode":"IL"},{"stateId":19,"stateName":"Indiana","stateCode":"IN"},{"stateId":20,"stateName":"Iowa","stateCode":"IA"},{"stateId":21,"stateName":"Kansas","stateCode":"KS"},{"stateId":22,"stateName":"Kentucky","stateCode":"KY"},{"stateId":23,"stateName":"Louisiana","stateCode":"LA"},{"stateId":24,"stateName":"Maine","stateCode":"ME"},{"stateId":25,"stateName":"Maryland","stateCode":"MD"},{"stateId":26,"stateName":"Massachusetts","stateCode":"MA"},{"stateId":27,"stateName":"Michigan","stateCode":"MI"},{"stateId":28,"stateName":"Minnesota","stateCode":"MN"},{"stateId":29,"stateName":"Mississippi","stateCode":"MS"},{"stateId":30,"stateName":"Missouri","stateCode":"MO"},{"stateId":31,"stateName":"Montana","stateCode":"MT"},{"stateId":32,"stateName":"Nebraska","stateCode":"NE"},{"stateId":33,"stateName":"Nevada","stateCode":"NV"},{"stateId":34,"stateName":"New Hampshire","stateCode":"NH"},{"stateId":35,"stateName":"New Jersey","stateCode":"NJ"},{"stateId":36,"stateName":"New Mexico","stateCode":"NM"},{"stateId":37,"stateName":"New York","stateCode":"NY"},{"stateId":38,"stateName":"North Carolina","stateCode":"NC"},{"stateId":39,"stateName":"North Dakota","stateCode":"ND"},{"stateId":40,"stateName":"Ohio","stateCode":"OH"},{"stateId":41,"stateName":"Oklahoma","stateCode":"OK"},{"stateId":42,"stateName":"Oregon","stateCode":"OR"},{"stateId":43,"stateName":"Pennsylvania","stateCode":"PA"},{"stateId":44,"stateName":"Puerto Rico","stateCode":"PR"},{"stateId":45,"stateName":"Rhode Island","stateCode":"RI"},{"stateId":46,"stateName":"South Carolina","stateCode":"SC"},{"stateId":47,"stateName":"South Dakota","stateCode":"SD"},{"stateId":48,"stateName":"Tennessee","stateCode":"TN"},{"stateId":49,"stateName":"Texas","stateCode":"TX"},{"stateId":50,"stateName":"Utah","stateCode":"UT"},{"stateId":51,"stateName":"Vermont","stateCode":"VT"},{"stateId":52,"stateName":"Virginia","stateCode":"VA"},{"stateId":53,"stateName":"Washington","stateCode":"WA"},{"stateId":54,"stateName":"West Virginia","stateCode":"WV"},{"stateId":55,"stateName":"Wisconsin","stateCode":"WI"},{"stateId":56,"stateName":"Wyoming","stateCode":"WY"}];
    setStateData(statesJson);
    /*
   fetch(
    "https://wagesurvey.smallnation.site/api/statesList")
    .then((res) => res.json())
                 .then((json) => {
                  setStateData(json);
                  console.log(typeof(json));
                  console.log("89-->"+JSON.stringify(json))
                });
     */



 },[]);
  return(
  <>
  <main  class="empr-directory-main">
         <div class="main-bgpatten"></div>
         <section class="headtitle-wrap">
            <div class="container">
               <div class="row">
                  <div class="col-lg-12">
                     <nav style={{"--bs-breadcrumb-divider": '>'}} aria-label="breadcrumb">
                        <ol class="breadcrumb">
                          <li class="breadcrumb-item headtitle "><a href="#">Employer Registration </a></li>
                        </ol>
                      </nav>
                  </div>
               </div>
            </div>
         </section>

         {/* <!-- info typography --> */}
         <section class="company-detail-wrap py-5 ">
            <div class="container">
               <div class="row">
                  <div class="col-12 ">
                     <div class="white-bg px-5 pt-4 pb-4">
                     <form onSubmit={handleSubmit(submitValue)}>
                      <div class="row resume-wrap">
                      <div class="col-lg-12 mb-4">

                      {(() => {
                         if( userIdChkLogin != null && userIdChkLogin != "null"){
                              return (<></>);
                          }else{
                            return (<><div className='border-bottom pb-4 mb-3 d-flex align-items-center justify-content-between'>
                              <h6 className='mb-0'>Do you already have a profile?</h6>
                              <a onClick={() => goLogin() } className='reg-button  text-center'>SIGN IN</a>
                </div></>);
                          }
                      })()}

                      {/* <div className='border-bottom pb-4 mb-3 d-flex align-items-center justify-content-between'>
                                    <h6 className='mb-0'>Do you already have a profile?</h6>
                                    <a onClick={() => goLogin() } className='reg-button  text-center'>Sign In</a>
                      </div> */}
                      </div>
                        <div class="col-lg-12 mb-4">
                            <label for="cname" class="form-label">Company Name<span class="red-text">*</span></label>
                            <input type="text" class="form-control" id="cname" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("Company", {
                                    required: "Company name is required.",

                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="Company"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />
                            <div class="invalid-feedback">
                              Valid first name is required.
                            </div>
                          </div>

                          <div class="col-lg-6 mb-4">
                           <label for="address" class="form-label">Address<span class="red-text">*</span></label>
                           <input type="text" class="form-control" id="address" placeholder=""  onChange={e => setFieldName(e.target.value)} {...register("Address", {
                                    required: "Address is required.",

                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="Address"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />

                         </div>

                         <div class="col-lg-6 mb-4">
                           <label for="address1" class="form-label">Address2</label>
                           <input type="text" class="form-control" id="address1" placeholder=""  required=""/>

                         </div>

                         <div class="col-lg-6 mb-4">
                           <label for="city" class="form-label">City<span class="red-text">*</span></label>
                           <input type="text" class="form-control" id="city" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("City", {
                                    required: "City is required.",

                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="City"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />

                         </div>

                         <div class="col-lg-6 mb-4">


                         <label for="state" class="form-label">State<span class="red-text">*</span></label>
                           <select class="form-select" id="state" aria-label="Default select example" {...register('state', { required: true })}>
                               <option selected value="">Select</option>
                                {
                                    stateData.map((state, index) => (
                                         <option  value={state.stateCode}>{state.stateName}</option>
                                    ))
                                }
                             </select>

                             {errors.state && errors.state.type === "required" && <div class="error">State is required</div>}
                           

                         </div>

                         <div class="col-lg-6 mb-4">
                           <label for="zipcode" class="form-label">Zip<span class="red-text">*</span></label>
                           <input type="text" class="form-control" id="zipcode" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("Zip", {
                                    required: "Zip is required.",
                                    pattern: {
                                      value:/^[\d./-]+$/,
                                      message: "Should allow only numerics"
                                    },

                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="Zip"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />

                         </div>


                          <div class="col-lg-6 mb-4">
                           <label for="county" class="form-label">County (where you have a physical location)</label>
                           <select class="form-select" id="county" aria-label="Default select example">
                               {/* <option selected>Both</option>
                               <option value="1">One</option>
                               <option value="2">Two</option>
                               <option value="3">Three</option> */}

                               {
                                locationCounty.map((data, index) => (
                                  <option value={data.jobLocationCountyId} >{data.name}</option>
                                  ))}
                             </select>
                         </div>

                         <div class="col-lg-6 mb-4">
                           <label for="yourphone2" class="form-label">Phone<span class="red-text">*</span></label>
                           <input type="text" class="form-control" id="yourphone2" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("Phone", {
                                    required: "Phone is required.",

                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="Phone"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />

                         </div>


                         <div class="col-12 my-4">
                            <h2 class="headtitle">Company Administrator Information</h2>
                         </div>

                         <div class="col-lg-6 mb-4">
                           <label for="firstName" class="form-label">First Name<span class="red-text">*</span></label><small></small>
                           <input type="text" class="form-control" id="adminFirstName" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("FirstName", {
                                    required: "First Name is required.",

                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="FirstName"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />

                         </div>


                         <div class="col-lg-6 mb-4">
                           <label for="adminLastName" class="form-label">Last Name<span class="red-text">*</span></label><small></small>
                           <input type="text" class="form-control" id="adminLastName" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("LastName", {
                                    required: "Last Name is required.",

                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="LastName"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />

                         </div>

                         <div class="col-lg-12 mb-4">
                           <label for="adminEmail" class="form-label">Email<span class="red-text">*</span></label><small>Must be valid for notifications</small>
                           <input type="text" class="form-control" id="adminEmail" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("Email", {
                                    required: "Email is required.",

                                    pattern: {
                                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                      message: "invalid email address"
                                    }
                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="Email"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />

                         </div>

                         <div class="col-lg-6 mb-4">
                           <label for="adminPassword" class="form-label">Password<span class="red-text">*</span></label>
                           <p style={{fontSize: "12px"}}>Must be a minimum of 8 characters & MUST include all of the following: a lowercase letter, an uppercase letter, a number, and a special character</p>
                           <span class="position-relative">
                           <input type={isRevealPwd ? "text" : "password"} class="form-control" id="adminPassword" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("Password", {
                                    required: "Password is required.",
                                    pattern: {
                                      value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                                      message: "Password contain uppercase,lowercase and special character"
                                    },
                                    minLength: { value: 8, message: 'Too short' }
                                    })}/>
                                     <img src={isRevealPwd ? hidePwdImg : showPwdImg}  class="pwdShowHideClsPostResume"
                                     onClick={() => setIsRevealPwd(prevState => !prevState)}
                                    alt=""/>
                                    </span>
                                 <ErrorMessage
                                    errors={errors}
                                    name="Password"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />

                         </div>

                         <div class="col-lg-6 mb-4">
                         <label for="passwordConf" class="form-label">Confirm Password<span class="red-text">*</span></label><small></small>
                         <p style={{fontSize: "12px"}}>Must be a minimum of 8 characters & MUST include all of the following: a lowercase letter, an uppercase letter, a number, and a special character</p>
                         <span class="position-relative">         
                         <input type={isRevealConfPwd ? "text" : "password"}  class="form-control" id="passwordConf" onChange={e => setFieldName(e.target.value)} {...register("PasswordConf", {
                          required: "Password is required.",
                          pattern: {
                            value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                            message: "Password contain uppercase,lowercase and special character"
                          },
                          minLength: { value: 8, message: 'Too short' }
                        })} />
                          <img src={isRevealConfPwd ? hidePwdImg : showPwdImg}  class="pwdShowHideClsPostResume"
                                     onClick={() => setIsRevealConfPwd(prevState => !prevState)}
                                    alt=""/>      
                        </span>
                        <ErrorMessage
                          errors={errors}
                          name="PasswordConf"
                          class="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} class="error">{message}</p>
                              ))
                              : null;
                          }}
                        />
                        <p id="matchPwd" class="error">Passwords must match</p>

                         </div>

                         <div class="col-12 my-4">
                           <h2 class="headtitle">Company Information </h2>
                        </div>

                        <div class="col-lg-6 mb-4">
                          <label for="nofEmp" class="form-label">Number of Employees<span class="red-text">*</span></label><small>Currently employed with your company.</small>
                          <input type="text" class="form-control" id="nofEmp" placeholder="" onChange={e => setFieldName(e.target.value)} {...register("noemployees", {
                                    required: "Number of Employees is required.",
                                    pattern: {
                                      value: /^[\d./-]+$/,
                                      message: "Should allow only numerics"
                                    },

                                    })}/>
                                 <ErrorMessage
                                    errors={errors}
                                    name="noemployees"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />
                          <div class="invalid-feedback">
                            Valid first name is required.
                          </div>
                        </div>

                        <div class="col-lg-6 mb-4">
                           <label for="websiteUrl" class="form-label">Website</label><small>Example: http://example.com</small>
                           <input type="text" class="form-control" id="websiteUrl" placeholder="" {...register("websiteUrlvalid", {
                                    pattern: {
                                      value: /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gi,

                                      message: "Invalid Website URL"
                                    },

                                    })}/>
                          <ErrorMessage
                                    errors={errors}
                                    name="websiteUrlvalid"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />
                         </div>



                          <div class="col-lg-12 mb-4">
                            <div class="d-flex"><label for="companyProfile" class="form-label mr-2">Company Profile <span class="red-text">*</span></label> </div>

                            {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="companyProfile"
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);

                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setCompanyProfile(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */}

<SunEditor
                              setOptions={{
                                height: "400",
                                //buttonList: [['font', 'align'], ['image']]

                                buttonList: [
                                  ['undo', 'redo'],
                                  ['font', 'fontSize', 'formatBlock'],
                                  ['paragraphStyle', 'blockquote'],
                                  ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                  ['fontColor', 'hiliteColor', 'textStyle'],
                                  ['removeFormat'],
                                  '/', // Line break
                                  ['outdent', 'indent'],
                                  ['align', 'horizontalRule', 'list', 'lineHeight'],
                                  ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                                  ['fullScreen', 'showBlocks', 'codeView'],
                                  ['preview'],

                                  /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                                ]
                                //buttonList: buttonList.complex
                                // plugins: [font] set plugins, all plugins are set by default
                                // Other option
                              }}
                              onChange={handleChangeProfileDesc}                             
                              //onImageUpload={handleImageUpload}
                              onImageUploadBefore={handleImageUploadBefore}
                            />
                         <div id="companyProfileValidMsg" class="error">Company Profile is required.</div>


                                    {/* <textarea class="form-control textarea" placeholder="Leave a comment here" id="companyProfile" onChange={e => setFieldName(e.target.value)} {...register("cprofile", {
                                    required: "Company Profile is required.",
                                    maxLength: { value: 2000, message: 'Should not allow more than 2000 character' }
                                    })}/>
                                  <ErrorMessage
                                    errors={errors}
                                    name="cprofile"
                                    class="invalid-feedback"
                                    render={({ messages }) => {
                                    console.log("messages", messages);
                                    return messages
                                        ? Object.entries(messages).map(([type, message]) => (
                                            <p key={type}  class="error">{message}</p>
                                        ))
                                        : null;
                                    }}
                                />  */}
                          </div>



                          <div class="col-lg-12 mb-4">
                            <div class="d-flex"><label for="industry" class="form-label mr-2 mb-3">Company Industry<span class="red-text">*</span></label> <small>Max 3 Categories</small></div>

                            <div>
                                <div class="category-check-itm">
                                    <ul class="category-check">
                                    {
                                        categories.map((category, index) => (
                                            <li><input class="form-check-input" type="checkbox" value={category.catId} name="category" id="category" {...register('category', { required: true })} onClick={()=>validateCheck()}/>  <label class="form-check-label" for="defaultCheck1"> {category.name} </label></li>
                                        ))
                                    }

                                    </ul>
                                </div>

                                {/* <div class="category-check-itm">
                                    <ul>
                                        <li><input class="form-check-input" type="checkbox" value="2" name="category" id="category"/>  <label class="form-check-label" for="defaultCheck1"> Accounting </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="3" name="category" id="category"/>  <label class="form-check-label" for="defaultCheck1"> Advanced Manufacturing</label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> Robotics </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> CNC  </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> Advertising and PR Services  </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> Agriculture and Food Processing  </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> Architectural and Design Services  </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> Art Athletic Training/Physical/ </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> Art Athletic Training/Physical/ </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> Occupational Therapy  </label></li>
                                        <li><input class="form-check-input" type="checkbox" value="" name="exp" id="defaultCheck1"/>  <label class="form-check-label" for="defaultCheck1"> Auto/Diesel </label></li>
                                    </ul>
                                </div> */}


                            </div>
                            {errors.category && errors.category.type === "required" && <div class="error">Please check atleast One category</div>}

                          </div>


                          <div class="col-lg-12 mb-4">
                            <div class="d-flex"><label for="industry" class="form-label mr-2 mb-3">Does your company provide Job Shadow opportunities? </label></div>

                            <div>
                                <div class="category-check-itm">
                                  <input class="form-check-input" type="radio" value="Y" name="job_shadow" id="job_shadow_y" />  <label class="form-check-label" for="defaultCheck1"> Yes </label> &nbsp; &nbsp; <input class="form-check-input" type="radio" value="N" name="job_shadow" id="job_shadow_n" />  <label class="form-check-label" for="defaultCheck1"> No </label>
                                </div>
                            </div>

                            <div id="jobShadowValidMsg" class="error">This field is required.</div>
                          </div>



                          <div class="col-lg-12 mb-4">

                            <div class="d-flex justify-content-between align-items-end choose">

                                <div><button type="submit" class="reg-button"  >Register</button></div>
                            </div>

                            <div id="alertFailMessage" class="alert alert-danger mt-3" role="alert" style={{ maxWidth:"320px"}}>

                            </div>

                          </div>

                      </div>

                      </form>

                     </div>



                  </div>

               </div>
            </div>
         </section>

         <section class="load-wrap">
            <div class="loadingIcon">
              <img src="images/loading.gif"></img>
              </div>
          </section>

      </main>

  </>
)};

CompanyRegister.propTypes = {};

CompanyRegister.defaultProps = {};

export default CompanyRegister;
